export default {"src":"/_next/static/media/logo.a3d32f4e.svg","height":32,"width":56,"blurWidth":0,"blurHeight":0};